import { render, staticRenderFns } from "./MainWrapper.vue?vue&type=template&id=3cec2fa0&scoped=true&"
import script from "./MainWrapper.vue?vue&type=script&lang=js&"
export * from "./MainWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec2fa0",
  null
  
)

export default component.exports